import { IAuth } from "../AuthContext";

abstract class BaseRoute {
  public path: string;
  public title: string;
  public component: any;

  constructor(path: string, title: string, component: any) {
    this.path = path;
    this.title = title;
    this.component = component;
  }

  public abstract isAllowed(auth: IAuth): boolean;
}

export { BaseRoute }
